import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(public db: AngularFirestore) {}

  getStatus(userId){
    return this.db.collection('useronlinestatus',ref => ref.where('userId', '==', userId))
        .snapshotChanges();
  }

  updateStatus(userId, value) {
    return this.db.collection('useronlinestatus').doc(userId).set(value);
  }

  updatePinnedStatus(physicianId, patientList) {
    return this.db.collection('pinnedPatients').doc(physicianId).set(patientList);
  }

  createPinnedStatus(physicinId){
    return this.db.collection('pinnedPatients').doc(physicinId).set({
      patientList : []
    });
  }

  getPinnedPatients(physicianId){
    return this.db.collection('pinnedPatients').doc(physicianId).get();
  }

  getAllPinnedPatients(){
    return this.db.collection('pinnedPatients').get();
  }

  getPinnedMetrics(physicianId){
    return this.db.collection('pinnedMetrics').doc(physicianId).get();
  }

  updatePinnedMetric(physicianId, metricList) {
    return this.db.collection('pinnedMetrics').doc(physicianId).set(metricList);
  }

  createPinnedMetric(physicinId){
    return this.db.collection('pinnedMetrics').doc(physicinId).set({
      metricList : []
    });
  }

  getAllProfileDefaults() {
    return this.db.collection('physicianProfileData').snapshotChanges();
  }


}

